import { MouseEventHandler, useEffect } from "react";
import PORGLogo from "./PORGLogo";
import { Link } from "react-router-dom";

interface Props {
    logout: MouseEventHandler;
    isTeacher: boolean
}

function Header({logout, isTeacher}: Props) {

    useEffect(() => {
        document.addEventListener('click', function(event) {
            var isClickInside = document.querySelector('.dropdown')?.contains(event.target as Node);
            if (!isClickInside) {
                (document.querySelector('.menu') as HTMLElement).style.display = 'none';
                (document.querySelector('.caret') as HTMLElement).style.transform = 'rotate(0deg)';
            }
        });
    }, [])

    const menuOnClick = () => {
        var menu = document.querySelector('.menu') as HTMLElement;
            var caret = document.querySelector('.caret') as HTMLElement;
            var isMenuOpen = menu?.style.display === 'block';
            
            menu.style.display = isMenuOpen ? 'none' : 'block';
            caret.style.transform = isMenuOpen ? 'rotate(0deg)' : 'rotate(180deg)';
    }

    return ( 
    <>

<div className="header">
    <div className="d-flex justify-content-between align-items-center w-100 center-align">
        <div className="content row center-align">
        <PORGLogo/>
            <div className="school-name ml-3">Libeň</div> {/* TODO: Fix logo - make it smaller and not absolutely positioned*/}
        </div>
        <div className="dropdown">
            <div className="select" onClick={menuOnClick}>
                <span>Menu</span>
                <div className="caret"></div>
            </div>
            <ul className="menu">
                {isTeacher ? <>
                    <Link to="/" className="text-link"><li><i className="bi bi-person-vcard-fill"></i>Moje Kroužky</li></Link>
                    <Link to="/editCourse" className="text-link"><li><i className="bi bi-pencil-square"></i>Vytvořit kroužek</li></Link>
                    <Link to="/"><li className="border-botto logout-btn" onClick={logout}><i className="bi bi-box-arrow-right"></i>Odhlásit se</li></Link>
                </> : <>
                <Link to="/" className="text-link"><li><i className="bi bi-backpack2-fill"></i>Kroužky</li></Link>
                {/*<Link to="/myCourses" className="text-link"><li><i className="bi bi-person-vcard-fill"></i>Moje Kroužky</li></Link>*/}
                <Link to="/"><li className="border-botto logout-btn" onClick={logout}><i className="bi bi-box-arrow-right"></i>Odhlásit se</li></Link>
                </>}
                
            </ul>
        </div>
    </div>
</div>

    </>
     );
}

export default Header;